<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div>
      <!-- <mrc_ess_iconGroup
        style="top: -50px"
        :is_disabled="disabled"
        :showEdit="hasBtn('edit-organizaiton-configuration')"
        :show_del="hasBtn('delete-organization-configuration')"
        @handleReturn="handleReturn"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup> -->
      <v-card>
        <v-card-text>
          <v-row>
            <v-col class="d-flex"
                   cols="12"
                   sm="12">
              <mrc_ess_prompt :errMsg="$errors('params', 'zone_uuid', requiredRule)"
                              :disabled="disabled"
                              :rules="false"
                              :label="$t('label_The_time_zone') + '*'"
                              :obj="zone_time"
                              v-model="params.zone_uuid">
              </mrc_ess_prompt>
            </v-col>
            <v-col class="d-flex"
                   cols="12"
                   sm="12">
              <mrc_ess_prompt :errMsg="$errors('params', 'language_code', requiredRule)"
                              :disabled="disabled"
                              :rules="false"
                              :label="$t('label_The_default_language') + '*'"
                              :obj="language_client"
                              v-model="params.language_code">
              </mrc_ess_prompt>
            </v-col>
            <v-col class="d-flex"
                   cols="12"
                   sm="12">
              <!-- :errMsg="$errors('params', 'language_arr', requiredRule)" -->
              <mrc_ess_prompt :disabled="disabled"
                              :rules="false"
                              :label="$t('label_Other_languages')"
                              :obj="language_client"
                              multiple
                              v-model="params.language_arr">
              </mrc_ess_prompt>
            </v-col>
          </v-row>
        </v-card-text>
        <mrc_ess_submitBtn @cancel="cancel"
                           v-if="!disabled"
                           :loading="loading"
                           @success="success"></mrc_ess_submitBtn>
      </v-card>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {
  lang_add,
  lang_update,
  lang_find,
  lang_del,
  get_company_del,
} from '@/service/api/company_set'
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data () {
    return {
      loading: false,
      skLoading: true,
      params: {
        org_level_uuid: '',
        language_code: '',
        language_arr: [],
        zone_uuid: '',
        uuid: '', // language表uuid
        time_zone_uuid: '', // time_zone表uuid
      },
    }
  },
  validations: {
    params: {
      language_code: {
        required,
      },
      zone_uuid: {
        required,
      },
      language_arr: {
        // required,
      },
    },
  },
  created () { },
  async mounted () {
    this.skLoading = true
    this.params.org_level_uuid = this.$store.state.uuid
    await this.getData()
    this.skLoading = false
  },
  methods: {
    async getData () {
      const info = await lang_find({
        org_level_uuid: this.params.org_level_uuid,
      })
      //  console.log(info)
      if (info.code == 200) {
        this.params.language_code = info.data.language_code
          ; (this.params.language_arr = info.data.language_arr
            ? info.data.language_arr.split(',')
            : []),
            (this.params.zone_uuid = info.data.zone_uuid)
        this.params.uuid = info.data.uuid
        this.params.time_zone_uuid = info.data.time_zone_uuid
      }
    },
    cancel () {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      })
        .then(async () => {
          // this.$router.push({
          //   name: 'enterprise'
          // })
          await this.getData()
          // this.disabled = !this.disabled

          this.$emit('cancel', !this.disabled)
        })
        .catch(() => { })
    },
    async success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      const obj = this.$clone(this.params)
      if (obj.language_arr.includes(obj.language_code)) {
        this.$myConfirm({
          content: this.$t('message_default_language_must_be_selected'),
        })
          .then(() => { })
          .catch(() => { })
        return
      }
      obj.language_arr = obj.language_arr.join()
      this.loading = true
      let update
      if (obj.uuid) {
        update = await lang_update(obj)
      } else {
        update = await lang_add(obj)
        if (update.code == 200) {
          this.params.uuid = update.data.uuid
        }
      }
      if (update.code == 200) {
        this.params.uuid = update.data.uuid
        this.$Message({
          text: this.$t('message_The_submission_was_successful'),
        })
        this.$emit('changeiconStatus')
      }
      this.loading = false
    },
    handleReturn () {
      this.$router.go(-1)
    },
    handleEdit () {
      this.disabled = !this.disabled
    },
    // 删除
    handleDel () {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_deletion'),
      })
        .then(async () => {
          const del = await get_company_del({
            uuid: this.$store.state.listObj.uuid,
          })
          if (del.code == 200) {
            this.delData(this.$store.state.listObj.uuid)
            this.$Message({
              text: this.$t('message_The_deletion_was_successful'),
            })
            if (
              this.$store.state.userData.userType != 1 &&
              this.$store.state.userData.userType != 4
            ) {
              await this.$store.dispatch('set_topcompanylist')
            }
            this.$router.push({
              name: 'enterprise',
            })
          }
        })
        .catch(() => { })
      // this.$myConfirm({ content: '是否删除' })
      //   .then(async () => {
      //     const del = await lang_del({
      //       org_level_uuid: this.params.org_level_uuid,
      //     })
      //     if (del.code == 200) {
      //       this.$Message({
      //         text: this.$t('message_The_deletion_was_successful'),
      //       })
      //       this.$router.go(-1)
      //     }
      //   })
      //   .catch(() => { })
    },
  },
  computed: {
    zone_time () {
      return {
        prompt_name: 'zone_time',
        org_level_uuid: this.$store.state.uuid,
      }
    },
    language_client () {
      return {
        prompt_name: 'language_client',
        client_uuid: this.$store.state.uuid2,
      }
    },
  },
  watch: {},
}
</script>

<style scoped></style>
